import ECSEditor from 'components/editor/ECSEditor';
import ECSSheet from 'components/editor/ECSSheet';
import ZoomControls from 'components/viewer/toolbars/ZoomControls';
import AppStoreContext, { AppStore } from 'contexts/AppStoreContext';
import ViewerFooterDownload from 'pages/ViewerPage/ViewerFooter/ViewerFooterDownload';
import React from 'react';
import { SheetVersion } from 'records/SheetVersion';

const editorContainerId = 'rfi-drawing-modal-container';

interface Props {
  sheetVersion: SheetVersion;
}

class RFIDrawingModal extends React.Component<Props, AppStore> {
  handleCloseModal = (): void => {
    this.context.actions.clearAllModals();
  };

  static modalStyles = {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    content: {
      padding: '0',
      margin: '0',
      left: '1.5rem',
      top: '1.5rem',
      right: '1.5rem',
      bottom: '1.5rem',
      borderRadius: '8px',
      border: 'none',
    },
  };

  static contextType = AppStoreContext;

  render(): React.ReactNode {
    const { sheetVersion } = this.props;
    const { documentid, pageid } = sheetVersion;

    return (
      <div className="column h100 justify-between">
        <div
          className="hs3 row items-center justify-between px3 pos-r"
          style={{ zIndex: 1, boxShadow: '2px 0 10px 0 rgba(0, 0, 0, 0.2)' }}
        >
          <span>{sheetVersion.sheetnumber}</span>
          <span
            className="flex-center line-height-1 font-size-9 cursor-pointer"
            onClick={this.handleCloseModal}
          >
            &times;
          </span>
        </div>
        <ECSEditor containerId={editorContainerId} isModal isScrollable={false}>
          <ECSSheet
            documentid={documentid}
            pageid={pageid}
            withMarkups={false}
            isInteractive={false}
          />
          <ZoomControls />
        </ECSEditor>
        <div className="hs3 w100 bt-1 row items-center">
          <ViewerFooterDownload sheetVersion={sheetVersion} />
        </div>
      </div>
    );
  }
}

export default RFIDrawingModal;
